import PropTypes from 'prop-types';

import RandomizedRender from 'core/components/RandomizedRender';
import ExchangeContext from './ExchangeContext';
import ExchangeWithMarkup from './ExchangeWithMarkup';


function Exchange(props) {
  const {
    pageType,
    blockType,
  } = props;

  return (
    <ExchangeContext.Consumer>
      {config => {
        const exchange = config?.[pageType]?.[blockType];

        if (!exchange || exchange?.length === 0) return null;

        if (exchange.length === 1)  {
          return (
            <ExchangeWithMarkup
              partner={exchange[0]}
              pageType={pageType}
              blockType={blockType}
            />
          );
        }

        const probabilities = exchange.map(item => item.percent);

        return (
          <RandomizedRender probabilities={probabilities}>
            {exchange.map((item, i) => (
              <ExchangeWithMarkup
                key={i}
                partner={item}
                pageType={pageType}
                blockType={blockType}
              />
            ))}
          </RandomizedRender>
        );
      }}
    </ExchangeContext.Consumer>
  );
}

Exchange.propTypes = {
  pageType: PropTypes.string.isRequired,
  blockType: PropTypes.string.isRequired,
};

export default Exchange;
